
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M21 15.4904L17.6595 20.25L15 17.7237L15.6186 17.102L17.5231 18.9111L20.2681 15L21 15.4904Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M13.4168 21.8725C12.5329 20.8274 12 19.4759 12 18C12 14.6863 14.6863 12 18 12C19.0023 12 19.9472 12.2458 20.7778 12.6804V4.90476L11.8889 2L3 4.90476V13.4286C3 15.7019 3.93651 17.882 5.6035 19.4895C7.27049 21.0969 9.53141 22 11.8889 22C12.4046 22 12.9156 21.9568 13.4168 21.8725ZM17.1727 9.73994L11.6727 14.7399L10.9671 15.3813L10.2929 14.7071L7.29289 11.7071L8.70711 10.2929L11.0329 12.6187L15.8273 8.26006L17.1727 9.73994Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowVerificationCodeVerificationFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
